import { render, staticRenderFns } from "./moSelectMessageUser.vue?vue&type=template&id=24803e55&scoped=true&"
import script from "./moSelectMessageUser.vue?vue&type=script&lang=js&"
export * from "./moSelectMessageUser.vue?vue&type=script&lang=js&"
import style0 from "./moSelectMessageUser.vue?vue&type=style&index=0&id=24803e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24803e55",
  null
  
)

export default component.exports